export default __webpack_public_path__ + "static/media/InterFontIcons.6ce22d97.eot";